var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-header d-none d-xl-block container position-relative"},[_c('button',{staticClass:"position-absolute",on:{"click":_vm.toggleHeader}},[(_vm.headerHidden)?_c('i',{staticClass:"fas fa-angle-down"}):_c('i',{staticClass:"fas fa-angle-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }